function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "replicate-furniture-cut"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: "10.5",
  y: "10.5",
  width: "14",
  height: "14",
  rx: "1.5",
  fill: "#000"
})), /*#__PURE__*/React.createElement("path", {
  mask: "url(#replicate-furniture-cut)",
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 12h7a1 1 0 011 1v3.2h-9V13a1 1 0 011-1zM12 16.5h2.8v4.3H12zm9.2 0H24v4.3h-2.8zm-6.4 1.3h6.4v3h-6.4zm-2 3.5h1.6V24h-1.6zm8.8 0h1.6V24h-1.6z"
})));